<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card p-1">
            <div class="row">
              <div class="col-md-6 mb-1">
                <label><span class="required">*</span> Título</label>
                <input
                  v-model="worktime.title"
                  type="text"
                  class="form-control"
                >
              </div>
              <div class="col-md-6">
                <label><span class="required">*</span> Empresa</label>
                <select
                  v-model="worktime.company_id"
                  class="form-control"
                >
                  <option
                    v-for="company in companies"
                    :key="company.id"
                    :value="company.id"
                  >
                    {{ company.company_name }}
                  </option>
                </select>
              </div>
              <div class="col-md-6 mb-1">
                <label><span class="required">*</span> Início da Jornada</label>
                <date-time
                  v-model="worktime.started_at"
                  format="YYYY-MM-DD"
                  formatted="DD/MM/YYYY"
                  output-format="YYYY-MM-DD"
                  :only-date="true"
                  :no-button-now="true"
                >
                  <input
                    type="text"
                    class="form-control"
                    :value="worktime.started_at"
                  >
                </date-time>
              </div>
              <div class="col-md-6 mb-1">
                <label><span class="required">*</span> Fim da Jornada</label>
                <date-time
                  v-model="worktime.ended_at"
                  format="YYYY-MM-DD"
                  formatted="DD/MM/YYYY"
                  output-format="YYYY-MM-DD"
                  :only-date="true"
                  :no-button-now="true"
                >
                  <input
                    type="text"
                    class="form-control"
                    :value="worktime.ended_at"
                  >
                </date-time>
              </div>
              <div class="col-md-12 mb-1">
                <label><span class="required">*</span> Descrição</label>
                <textarea
                  v-model="worktime.description"
                  class="form-control"
                  cols="30"
                  rows="10"
                />
              </div>
              <div class="col-md-6 mb-1">
                <label><span class="required">*</span> Quantidade de horas</label>
                <input
                  v-model.number="worktime.hours"
                  type="number"
                  class="form-control"
                  min="1"
                  max="24"
                  step="1"
                >
              </div>
              <div class="col-md-6 mb-1">
                <label>Horário de Entrada Esperado</label>
                <input
                  v-model="worktime.expected_entry_time"
                  type="time"
                  class="form-control"
                >
                <small class="text-muted">Ex: 08:00</small>
              </div>

              <div class="col-md-6 mb-1">
                <label>Horário de Saída Esperado</label>
                <input
                  v-model="worktime.expected_exit_time"
                  type="time"
                  class="form-control"
                >
                <small class="text-muted">Ex: 17:00</small>
              </div>
              <div class="col-md-6 mb-1">
                <label>Horas Mensais Esperadas</label>
                <input
                  v-model.number="worktime.monthly_hours"
                  type="number"
                  class="form-control"
                  min="0"
                  step="1"
                >
              </div>
              <div class="col-md-6 mb-1">
                <label>Horas de Intervalo (por jornada)</label>
                <input
                  v-model.number="worktime.interval_hours"
                  type="number"
                  class="form-control"
                  min="0"
                  step="0.25"
                >
                <small class="text-muted">Defina quantas horas de intervalo esta jornada prevê (ex: 1 para 1h, 2 para 2h).</small>
              </div>
              <div class="col-md-6 mb-1">
                <label><span class="required">*</span> Padrão?</label>
                <select
                  v-model="worktime.default"
                  class="form-control"
                >
                  <option :value="0">
                    Não
                  </option>
                  <option :value="1">
                    Sim
                  </option>
                </select>
              </div>

              <div class="col-md-12 mt-2">
                <hr>
                <h5 class="mb-0">
                  <i class="fa fa-sliders" /> Regras da Jornada
                </h5>
                <small class="text-muted d-block mb-2">
                  Opcional. Sem regras, a jornada funciona como hoje. As regras
                  usam o <strong>horário de entrada/saída esperado</strong>
                  definido acima.
                </small>
              </div>

              <!-- Regras de batida fora do horário (várias) -->
              <div class="col-md-12 mb-2">
                <div class="rule-card-head mb-1">
                  <i class="fa fa-clock-o text-primary mr-1" />
                  <strong>Batidas fora do horário previsto</strong>
                </div>
                <p class="text-muted small mb-2">
                  O que fazer quando a pessoa bate ponto fora da janela esperada
                  (já considerando a tolerância da empresa). Você pode adicionar
                  várias regras (ex.: auto-aprovar atraso na entrada e sinalizar a saída).
                </p>

                <div
                  v-for="(r, i) in ruleForm.punchRules"
                  :key="'pr-' + i"
                  class="card rule-card p-2 mb-2"
                >
                  <div class="row">
                    <div class="col-md-5 mb-1">
                      <label class="small mb-0">Ação</label>
                      <select
                        v-model="r.action"
                        class="form-control"
                      >
                        <option value="flag">
                          Sinalizar para revisão do gestor
                        </option>
                        <option value="auto_approve">
                          Aprovar automaticamente (atraso)
                        </option>
                        <option value="block">
                          Bloquear a batida
                        </option>
                        <option value="warn">
                          Aceitar e avisar a pessoa
                        </option>
                        <option value="ignore">
                          Aceitar sem sinalizar
                        </option>
                      </select>
                    </div>
                    <div class="col-md-3 mb-1">
                      <label class="small mb-0">Aplicar a</label>
                      <select
                        v-model="r.appliesTo"
                        class="form-control"
                      >
                        <option value="both">
                          Entrada e saída
                        </option>
                        <option value="entry">
                          Só entrada
                        </option>
                        <option value="exit">
                          Só saída
                        </option>
                      </select>
                    </div>
                    <div class="col-md-3 mb-1">
                      <label class="small d-block mb-0">Tipos de batida</label>
                      <label class="small mr-2">
                        <input
                          v-model="r.punchPresencial"
                          type="checkbox"
                        >
                        Presencial
                      </label>
                      <label class="small">
                        <input
                          v-model="r.punchRemote"
                          type="checkbox"
                        >
                        Remota
                      </label>
                    </div>
                    <div class="col-md-1 mb-1 d-flex align-items-end">
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-danger"
                        title="Remover regra"
                        @click="removePunchRule(i)"
                      >
                        <i class="fa fa-trash" />
                      </button>
                    </div>
                  </div>
                  <p class="small mb-0 rule-hint">
                    <i class="fa fa-info-circle" /> {{ explainPunchAction(r.action) }}
                  </p>
                </div>

                <button
                  type="button"
                  class="btn btn-sm btn-outline-primary"
                  @click="addPunchRule"
                >
                  <i class="fa fa-plus" /> Adicionar regra de batida
                </button>
              </div>

              <!-- Regra 2: hora extra -->
              <div class="col-md-12 mb-1">
                <div class="card rule-card p-2">
                  <div class="rule-card-head">
                    <i class="fa fa-hourglass-half text-warning mr-1" />
                    <strong>Hora extra</strong>
                  </div>
                  <div class="row">
                    <div class="col-md-6 mb-1">
                      <label class="small mb-0">Como tratar a hora extra?</label>
                      <select
                        v-model="ruleForm.overtimeMode"
                        class="form-control"
                      >
                        <option value="">
                          Não controlar (creditar tudo)
                        </option>
                        <option value="always">
                          Sempre exigir aprovação do gestor
                        </option>
                        <option value="allowance">
                          Permitir um limite automático; aprovar acima
                        </option>
                      </select>
                    </div>
                  </div>

                  <div
                    v-if="ruleForm.overtimeMode === 'allowance'"
                    class="row"
                  >
                    <div class="col-md-12">
                      <p class="text-muted small mb-2">
                        Hora extra <strong>dentro do limite</strong> é creditada
                        automaticamente. <strong>Acima do limite</strong>, fica
                        pendente de aprovação do gestor.
                      </p>
                    </div>
                    <div class="col-md-4 mb-1">
                      <label class="small mb-0">
                        Hora extra permitida antes da entrada
                      </label>
                      <input
                        v-model="ruleForm.overtimeBefore"
                        type="time"
                        class="form-control"
                      >
                    </div>
                    <div class="col-md-4 mb-1">
                      <label class="small mb-0">
                        Hora extra permitida depois da saída
                      </label>
                      <input
                        v-model="ruleForm.overtimeAfter"
                        type="time"
                        class="form-control"
                      >
                    </div>
                  </div>

                  <p
                    v-if="ruleForm.overtimeMode"
                    class="small mb-1 rule-hint"
                  >
                    <i class="fa fa-info-circle" /> {{ overtimeExplanation }}
                  </p>

                  <p class="text-muted small mb-0">
                    <i class="fa fa-shield" /> Hora extra autorizada (escala de
                    hora extra ou liberação aprovada) é sempre creditada, sem
                    pedir aprovação.
                  </p>
                </div>
              </div>
            </div>

            <div class="block text-right mb-1">
              <router-link
                to="/worktime"
                class="btn btn-back"
              >
                <i class="fa fa-arrow-left" /> Voltar
              </router-link>
              <a
                class="btn btn-add ml-1"
                @click="save"
              >
                Salvar
                <i class="fa fa-save" />
              </a>
            </div>
            <div class="row">
              <div class="col-md-4">
                <p><span class="required">*</span> Campos Obrigatórios</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vSelect from 'vue-select'
import BaseCrud from '../../layouts/Base/BaseCrud'

export default {
  name: 'ImageUpload',
  components: {
    BaseCrud,
    vSelect,
  },
  data() {
    return {
      worktime: {},
      companies: [],
      ruleForm: {
        punchRules: [],
        overtimeMode: '', // "" = não controlar | "always" | "allowance"
        overtimeBefore: '00:00', // permitido antes da entrada (HH:MM)
        overtimeAfter: '00:00', // permitido depois da saída (HH:MM)
      },
    }
  },
  computed: {
    overtimeExplanation() {
      if (this.ruleForm.overtimeMode === 'always') {
        return 'Qualquer hora extra (entrada antes ou saída depois do previsto) fica pendente de aprovação. O gestor aprova (credita) ou rejeita (usa o horário da jornada).'
      }

      if (this.ruleForm.overtimeMode === 'allowance') {
        const before = this.ruleForm.overtimeBefore || '00:00'
        const after = this.ruleForm.overtimeAfter || '00:00'
        return `Hora extra de até ${before} antes da entrada e ${after} depois da saída é creditada automaticamente. Acima disso, vai para aprovação do gestor.`
      }

      return ''
    },
  },
  watch: {},
  mounted() {
    const self = this
    const { id } = self.$route.params

    if (id) {
      self.getWorktime(id)
    }
    self.getCompanies()
  },
  methods: {
    addPunchRule() {
      this.ruleForm.punchRules.push({
        action: 'flag',
        appliesTo: 'both',
        punchPresencial: true,
        punchRemote: true,
      })
    },
    removePunchRule(i) {
      this.ruleForm.punchRules.splice(i, 1)
    },
    explainPunchAction(action) {
      switch (action) {
        case 'flag':
          return 'A batida é registrada e sinalizada para o gestor revisar (aprovar ou corrigir o horário).'
        case 'auto_approve':
          return 'Atrasos são aceitos e aprovados automaticamente (contam no saldo, sem ir para a tela de aprovação). Hora extra continua exigindo aprovação.'
        case 'block':
          return 'A batida é bloqueada e não é registrada.'
        case 'warn':
          return 'A batida é registrada normalmente, mas a pessoa recebe um aviso.'
        case 'ignore':
          return 'A batida é registrada normalmente, sem nenhuma sinalização.'
        default:
          return ''
      }
    },
    buildRules() {
      const rules = [];

      (this.ruleForm.punchRules || []).forEach(r => {
        if (!r.action) return
        const punchTypes = []
        if (r.punchPresencial) punchTypes.push('presencial')
        if (r.punchRemote) punchTypes.push('remote')

        rules.push({
          type: 'punch_window',
          action: r.action,
          applies_to: r.appliesTo || 'both',
          punch_types: punchTypes.length ? punchTypes : null,
          active: true,
        })
      })

      if (this.ruleForm.overtimeMode === 'always') {
        rules.push({
          type: 'cap_overtime',
          active: true,
          params: { mode: 'always' },
        })
      } else if (this.ruleForm.overtimeMode === 'allowance') {
        rules.push({
          type: 'cap_overtime',
          active: true,
          params: {
            mode: 'allowance',
            before_minutes: this.timeToMinutes(this.ruleForm.overtimeBefore),
            after_minutes: this.timeToMinutes(this.ruleForm.overtimeAfter),
          },
        })
      }

      return rules
    },
    timeToMinutes(value) {
      if (!value || typeof value !== 'string') return 0
      const [h, m] = value.split(':').map(n => parseInt(n, 10) || 0)
      return h * 60 + m
    },
    minutesToTime(minutes) {
      const total = parseInt(minutes, 10) || 0
      const h = String(Math.floor(total / 60)).padStart(2, '0')
      const m = String(total % 60).padStart(2, '0')
      return `${h}:${m}`
    },
    hydrateRules(rules) {
      if (!Array.isArray(rules)) return

      this.ruleForm.punchRules = rules
        .filter(r => r.type === 'punch_window')
        .map(r => {
          const types = Array.isArray(r.punch_types)
            ? r.punch_types
            : ['presencial', 'remote']
          return {
            action: r.action || 'flag',
            appliesTo: r.applies_to || 'both',
            punchPresencial: types.includes('presencial'),
            punchRemote: types.includes('remote'),
          }
        })

      const cap = rules.find(r => r.type === 'cap_overtime')
      if (cap) {
        const params = cap.params || {}
        this.ruleForm.overtimeMode = params.mode === 'allowance' ? 'allowance' : 'always'
        this.ruleForm.overtimeBefore = this.minutesToTime(params.before_minutes)
        this.ruleForm.overtimeAfter = this.minutesToTime(params.after_minutes)
      }
    },
    save() {
      const self = this
      let api = `${self.$store.state.api}worktimes`

      self.worktime.rules = self.buildRules()

      if (self.worktime.id) {
        api += `/${self.worktime.id}`
        self.worktime._method = 'PUT'
      }

      axios
        .post(api, self.worktime)
        .then(response => {
          self.$message(
            'Sucesso',
            'Informações guardadas com sucesso',
            'success',
          )
          this.$router.push('/worktime')
        })
        .catch(error => {
          self.$message(null, error.response.data, 'error')
        })
    },
    getWorktime(id) {
      const self = this
      const api = `${self.$store.state.api}worktimes/${id}?with=rules`

      axios
        .get(api)
        .then(response => {
          self.worktime = response.data.data[0]
          self.hydrateRules(self.worktime.rules)
        })
        .catch(error => {
          self.$message(null, error.response.data, 'error')
        })
    },
    getCompanies() {
      const self = this
      const api = `${self.$store.state.api}companies`

      axios
        .get(api)
        .then(response => {
          console.log(response)
          self.usersLoading = true
          self.companies = response.data.data
        })
        .catch(error => {
          // vm.$toast.error(error.response.data.message);
        })
    },
  },
}
</script>
<style scoped>
.rule-card {
  border: 1px solid #e3e6f0;
  border-left: 4px solid #4e73df;
  border-radius: 6px;
  background: #f8f9fc;
}
.rule-card-head {
  font-size: 15px;
  margin-bottom: 4px;
}
.rule-hint {
  color: #2c7be5;
}
.rule-card label {
  font-weight: 400;
}

.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>
